import { useThemeContext } from '../utils/ThemeContext';

export const useThemeToggle = () => {
  const { themeMode, toggleTheme, theme } = useThemeContext();
  
  return {
    theme: themeMode,
    toggleTheme,
    muiTheme: theme
  };
};
